import React, { useEffect, useState } from "react";
import PopAdminPresenter from "../../../../presenters/screens/pop-admin.presenter";
import Indicators from "./Indicators";
import { SingleCollapse } from "@/components/";
import Beneficiaries from "./Beneficiaries";
import Financial from "./Financial";
export interface IPropsStep {
  stepsData: any;
  columns: any;
}

const ModalFolllowUp: React.FC<IPropsStep> = ({ stepsData, columns }: IPropsStep) => {
  const [info, setInfo] = useState<any>();

  const view: any = {
    state: {
    },
  };

  const presenter = new PopAdminPresenter(view);

    useEffect(() => {
        const initialize = () => {
            let auxItems: any = {};
            for (const element of presenter.infoToDelete.itemsToDelete) {
                if (!!element.item.SubProyectoAnioId) {
                    let newItem = { ...element };
                    let year = presenter.followUpData.followIndex.find((x: any) => x.Id === element.item.SubProyectoAnioId)?.Anio;
                    newItem.year = year;
                    if (auxItems[newItem.item.SubProyectoAnioId]) auxItems[newItem.item.SubProyectoAnioId] = [...auxItems[newItem.item.SubProyectoAnioId], newItem];
                    else auxItems[newItem.item.SubProyectoAnioId] = [newItem];
                }
            }
            setInfo(auxItems);
        };
        if(!!presenter.infoToDelete) initialize();
        if(!presenter.infoToDelete) setInfo(null)
    }, [presenter.infoToDelete]);

    let dataKeys: any = info ? Object.keys(info) || [] : [];

    return (
        <div style={{ margin: "30px 0" }}>
            {!!dataKeys?.length && columns &&
                dataKeys.map((x: any) => {
                    let element = info[x];
                    return (
                        <SingleCollapse title={element[0].year} isOpen={false} key={element[0].year}>
                            <Indicators stepsData={stepsData} infoToDelete={element} year={element[0].year} dataColumns={columns.ind} />
                            <Beneficiaries stepsData={stepsData} infoToDelete={element} year={element[0].year} dataColumns={columns.ben} />
                            <Financial stepsData={stepsData} infoToDelete={element} year={element[0].year} dataColumns={columns.fin} />
                        </SingleCollapse>
                    );
                })
            }
        </div>
    );
};

export default ModalFolllowUp;
